import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { IonApp, IonContent, IonPage, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import axios from 'axios';
import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { useEffect, useContext } from 'react';
import AppLayout from '../../Components/AppLayout';
import AuthLayout from '../../Components/AuthLayout';
import NestedPageLayout from '../../Components/NestedPageLayout';
import KenLoader from '../../GlobalComponents/KenLoader';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import routes from '../../Utils/routes';
import { ConfigOptions } from '../../interfaces/Common';
import storageService from '../../Utils/storageService';
import Preference from '../Auth/Preference';
import GoalsAndMilestonesData from '../Milestones/components/MileStoneData';
import AddMilestones from '../Milestones/addmilestones';
import ViewAllCoe from '../Deals/Pages/ViewAllCoe';
import JuryPortal from '../JuryPortal';
import StartUpsProfile from '../JuryPortal/Startup';
import AssignedStartUps from '../JuryPortal/AssignedStartups';
import SideNavigation from '../VenuePortal/src/components/SideNavigation';
import { addRouteHistory } from '../VenuePortal/src/utils/helpers';
import Event from '../Events/pages/DashBoard';
import RegisterEvents from '../Events/components/RegisterEvents';
import CreatedEvents from '../Events/pages/CreatedEvents';
import AllEvents from '../Events/pages/AllEvents';
import HostEvent from '../Events/pages/HostEvent';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';

const MyProfile = React.lazy(() => import('../MyProfile'));
const ProfileDetails = React.lazy(() => import('../MyProfile/ProfileDetails'));

// chat
const Chat = React.lazy(() => import('../../Components/Chat'));
const Notifications = React.lazy(() => import('../../Components/Notifications'));
// auth
const Login = React.lazy(() => import('../Auth/Login/index'));
const OnBoarding = React.lazy(() => import('../OnBoarding/index'));
const ConnectSocials = React.lazy(() => import('../Auth/ConnectSocials'));
// home
const Home = React.lazy(() => import('../Home/index'));
const SpotlightDetails = React.lazy(() => import('../Home/SpotlightDetails'));

// goals and milestones
const GoalsAndMilestones = React.lazy(() => import('../Milestones/index'));

//mentors
const Mentors = React.lazy(() => import('../Mentors'));
const FeaturedMentors = React.lazy(() => import('../Mentors/FeaturedMentors'));
const MentorDetailPage = React.lazy(() => import('../Mentors/components/Mentorsdetails'));

const PortfolioDetails = React.lazy(() => import('../../Components/PortfolioDetails/PortfolioDetails'));
const EngagementSummaryDetails = React.lazy(() => import('../../Components/PortfolioDetails/EngagementSummaryDetails'));

// startups
const Startups = React.lazy(() => import('../Network/Startups'));
// events
// const Events = React.lazy(() => import('../Events'));
const EventDetails = React.lazy(() => import('../Events/pages/EventDetails/index'));
// const HostAnEvent = React.lazy(() => import('../Events/pages/HostEvent/index'));
const RegisteredEvents = React.lazy(() => import('../Events/pages/RegisteredEvents'));
// participate -> programs
const Programs = React.lazy(() => import('../Programs'));
const ProgramDetails = React.lazy(() => import('../Programs/ProgramDetails'));
// participate -> Challenges
const Challenges = React.lazy(() => import('../Participate/Challenges'));
// people
const People = React.lazy(() => import('../Network/People'));
const PeopleDetails = React.lazy(() => import('../Network/People/components/PeopleDetails'));
//Groups
const Groups = React.lazy(() => import('../Network/Groups/index'));
const DiscoverGroups = React.lazy(() => import('../Network/Groups/DiscoverGroups'));
const CreateGroup = React.lazy(() => import('../Network/Groups/CreateGroup'));
const DiscoverGroupsDetails = React.lazy(() => import('../Network/Groups/DiscoverGroupsDetails'));
const YourGroups = React.lazy(() => import('../Network/Groups/Your Groups'));
// coe
const COEDetails = React.lazy(() => import('../COE/COEDetails'));
// support
const Support = React.lazy(() => import('../Support'));
const TicketPreview = React.lazy(() => import('../Support/components/Ticket/TicketPreview'));
const Answers = React.lazy(() => import('../Support/components/Questions/Answers'));
const RequestService = React.lazy(() => import('../Support/components/Requests/RequestService'));
// mentors

// deals
const Deals = React.lazy(() => import('../Deals'));
const DealsDetails = React.lazy(() => import('../Deals/Pages/DealsDetails'));
const ViewALLOffers = React.lazy(() => import('../Deals/Pages/ViewALLOffers/index'));
// const RaiseRequest = React.lazy(() => import('../Support/components/RaiseRequest'));

// Venue Booking
const Facilities = React.lazy(() => import('../VenuePortal/src/pages/Facilities'));
const MeetingRooms = React.lazy(() => import('../VenuePortal/src/pages/MeetingRooms'));
const FacilityDetails = React.lazy(() => import('../VenuePortal/src/pages/FacilityDetails'));
const BookingFacility = React.lazy(() => import('../VenuePortal/src/pages/BookFacility'));
const FacilitiesCart = React.lazy(() => import('../VenuePortal/src/pages/FacilitiesCart'));
const FacilitiesBilling = React.lazy(() => import('../VenuePortal/src/pages/FacilitiesCart/components/FacilitiesCartBilling'));
const Bookings = React.lazy(() => import('../VenuePortal/src/pages/Bookings'));
const CalendarEvents = React.lazy(() => import('../VenuePortal/src/pages/Calendar'));
const MembershipOnboard = React.lazy(() => import('../VenuePortal/src/pages/MembershipOnboard'));
const AccessCardRequest = React.lazy(() => import('../VenuePortal/src/pages/AccessCardRequest'));

setupIonicReact();

const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();
  const {
    state: { isLoading: authLoading },
  } = useContext(AuthContext);
  const isMobile = useMediaQuery('(max-width:700px)');
  const { pathname, search } = useLocation();

  useEffect(() => {
    getConfig()
      .then(async (res: any) => {
        dispatch({ type: 'updateConfig', value: res?.config });
        dispatch({ type: 'updateLogo', value: res?.config?.Logo });
        if (res) {
          getAxiosInstance();
          const newroute = pathname + search;
          await addRouteHistory(newroute);
        }
        // Note: tokenUrl functionality removed as it's no longer needed with new config system
      })
      .catch((err) => {
        console.error('error in config', err);
      });
  }, []);

  const ResponsiveLayout = ({ children }: any) => {
    return isMobile ? <NestedPageLayout>{children}</NestedPageLayout> : <AppLayout>{children}</AppLayout>;
  };

  if (authLoading) {
    return <KenLoader />;
  }

  return config.apiBaseUrl === '' ? (
    <KenLoader />
  ) : (
    <IonApp>
      <IonRouterOutlet>
        <Switch>
          {/* Initial Route */}
          <Route exact path="/">
            <Redirect to={routes.login} />
          </Route>
          {/* Public Routes */}
          <Route
            exact
            path={routes.login}
            render={() => (
              <PublicRoute>
                <IonPage>
                  <AuthLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Login />
                    </React.Suspense>
                  </AuthLayout>
                </IonPage>
              </PublicRoute>
            )}
          />
          {/* Private Routes */}
          <Route
            exact
            path={routes.onboarding}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AuthLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <OnBoarding />
                    </React.Suspense>
                  </AuthLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.connectSocials}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AuthLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <ConnectSocials />
                    </React.Suspense>
                  </AuthLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* My Profile */}
          <Route
            exact
            path={routes.profileDetails}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                      <ProfileDetails />
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.preference}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <React.Suspense fallback={<KenLoader />}>
                    <Preference />
                  </React.Suspense>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.profile}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <MyProfile />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.notifcation}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Notifications />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.chat}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Chat />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Home */}
          <Route
            exact
            path={routes.featureStory}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <SpotlightDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.home}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Home />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Goals And Milestones */}
          <Route
            exact
            path={routes.addgoalmilestones}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <AddMilestones />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.goalsAndMilestones}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <GoalsAndMilestones />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Goals And Milestones Data*/}
          <Route
            exact
            path={routes.goalsAndMilestonesData}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <GoalsAndMilestonesData />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* mentors - Order matters: specific routes first, parameterized routes last */}
          <Route
            exact
            path={routes.featuredmentors}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <FeaturedMentors />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.mentors}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Mentors />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.mentorsdetails}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <MentorDetailPage />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Participate */}
          {/* Events */}
          {/* <Route
          path={routes.events}
          render={() => (
            <PrivateRoute>
              <AppLayout>
                <React.Suspense fallback={<KenLoader />}>
                  <Events />
                </React.Suspense>
              </AppLayout>
            </PrivateRoute>
          )}
        /> */}
          {/* <Route
          path={`${routes.eventDetail}/:eventId`}
          render={() => (
            <PrivateRoute>
              <AppLayout>
                <React.Suspense fallback={<KenLoader />}>
                  <EventDetails />
                </React.Suspense>
              </AppLayout>
            </PrivateRoute>
          )}
        />
        <Route
          path={routes.registeredEvents}
          render={() => (
            <PrivateRoute>
              <AppLayout>
                <React.Suspense fallback={<KenLoader />}>
                  <HostAnEvent />
                </React.Suspense>
              </AppLayout>
            </PrivateRoute>
          )}
        />
        <Route
          path={`${routes.hostEvent}`}
          render={() => (
            <PrivateRoute>
              <AppLayout>
                <React.Suspense fallback={<KenLoader />}>
                  <HostEvent />
                </React.Suspense>
              </AppLayout>
            </PrivateRoute>
          )}
        /> */}
          {/* Programs */}
          <Route
            exact
            path={routes.program}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Programs />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.programdetails}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <ProgramDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Challenges */}
          <Route
            exact
            path={routes.challenges}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Challenges />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* My Portfolio */}
      
          <Route
           exact
            path={`${routes.engagementrSummaryDetails}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <EngagementSummaryDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.myPortfolio}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <PortfolioDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Groups */}
          <Route
            path={`${routes.groups}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Groups />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.discoverGroups}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <DiscoverGroups />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.yourGroups}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <YourGroups />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.discoverGroups}/:groupId`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <DiscoverGroupsDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.createGroup}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <CreateGroup />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Startups */}
          <Route
            exact
            path={routes.startups}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Startups />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.startups}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <PortfolioDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.startupProfile}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <StartUpsProfile />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/*People */}
          <Route
            path={routes.people}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <People />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.allStartup}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <ResponsiveLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <AssignedStartUps />
                    </React.Suspense>
                  </ResponsiveLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.people}/:eventId`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <PeopleDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* COE */}
          <Route
            path={`${routes.coe}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Support />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.coe}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <COEDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.deals}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <COEDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Deals */}
          <Route
            exact
            path={`${routes.deals}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Deals />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
         
          <Route
            path={`${routes.viewAllCeo}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <ViewAllCoe />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
       
          <Route
            path={`${routes.viewAllOffers}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <ResponsiveLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <ViewALLOffers />
                    </React.Suspense>
                  </ResponsiveLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.dealsDetails}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <ResponsiveLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <DealsDetails />
                    </React.Suspense>
                  </ResponsiveLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />

          <Route
            path={`${routes.juryDashboard}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <ResponsiveLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <JuryPortal />
                    </React.Suspense>
                  </ResponsiveLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Support */}
          <Route
            exact
            path={`${routes.support}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Support />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.request}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>{/* <RaiseRequest /> */}</React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.support}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>{/* <RaiseEnquiry /> */}</React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.Answers}/:id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Answers />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.TicketPreview}`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <TicketPreview />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />

          <Route
            path={`${routes.requestService}`}
            exact
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <RequestService />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.faqs}/:Id`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>{/* <FaqQuestions /> */}</React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          {/* Jury Portal */}
          {/* Venue Booking */}
          <Route
            path={routes.meetings}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <SideNavigation>
                    <React.Suspense fallback={<KenLoader />}>
                      <MeetingRooms />
                    </React.Suspense>
                  </SideNavigation>
                </IonPage>
              </PrivateRoute>
            )}
          />

          <Route
            path={routes.accessCardRequest}
            render={() => {
              return (
                <PrivateRoute>
                  <IonPage>
                    {/* <SideNavigation> */}
                    <AccessCardRequest />
                    {/* </SideNavigation> */}
                  </IonPage>
                </PrivateRoute>
              );
            }}
          />
          <Route
            path={routes.facilitiesCart}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <SideNavigation>
                    <React.Suspense fallback={<KenLoader />}>
                      <FacilitiesCart />
                    </React.Suspense>
                  </SideNavigation>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.bookingFacility}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <SideNavigation>
                    <React.Suspense fallback={<KenLoader />}>
                      <BookingFacility />
                    </React.Suspense>
                  </SideNavigation>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.cartBilling}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <SideNavigation>
                    <React.Suspense fallback={<KenLoader />}>
                      <FacilitiesBilling />
                    </React.Suspense>
                  </SideNavigation>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={`${routes.facilityDetails}/:roomId`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <SideNavigation>
                    <React.Suspense fallback={<KenLoader />}>
                      <FacilityDetails />
                    </React.Suspense>
                  </SideNavigation>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.facilities}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Facilities />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.bookings}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Bookings />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.membership}
            render={() => (
              <PublicRoute>
                <IonPage>
                  <MembershipOnboard />
                </IonPage>
              </PublicRoute>
            )}
          />
          <Route
            path={routes.calendar}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <CalendarEvents />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={routes.registeredEvents}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <RegisteredEvents />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
           <Route
            exact
            path={routes.events}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <Event />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.hostEvent}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <HostEvent />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            exact
            path={`${routes.eventDetail}/:eventId`}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <EventDetails />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />

          <Route
            path={routes.registeredEvents}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <RegisterEvents />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.createdEvents}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <CreatedEvents />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route
            path={routes.allEvents}
            render={() => (
              <PrivateRoute>
                <IonPage>
                  <AppLayout>
                    <React.Suspense fallback={<KenLoader />}>
                      <AllEvents />
                    </React.Suspense>
                  </AppLayout>
                </IonPage>
              </PrivateRoute>
            )}
          />
          <Route render={() => <Redirect to={routes.login} />} />
        </Switch>
      </IonRouterOutlet>
    </IonApp>
  );
};

export default MainLayout;
